import React from "react";
import { ImageTemplate } from "themes/common/components";

function Image(props) {
    return <ImageTemplate {...props} />;
}

export default Image;
